/**
Copyright 2016 Split Software

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
**/

'use strict';

var timeout = require('../../utils/promise/timeout');
var tracker = require('../../utils/logger/timeTracker');

var mySegmentsService = require('../../services/mySegments');
var mySegmentsRequest = require('../../services/mySegments/get');

var mySegmentsFetcher = function mySegmentsFetcher(settings) {
  var shouldApplyTimeout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  tracker.start(tracker.C.SEGMENTS_FETCH);
  var requestPromise = mySegmentsService(mySegmentsRequest(settings));

  // Decorate with the timeout functionality if required
  if (shouldApplyTimeout) {
    requestPromise = timeout(settings.startup.requestTimeoutBeforeReady, requestPromise);
  }

  // Extract segment names
  return requestPromise.then(function (resp) {
    tracker.stop(tracker.C.SEGMENTS_FETCH);
    return resp;
  }).then(function (resp) {
    return resp.json();
  }).then(function (json) {
    return json.mySegments.map(function (segment) {
      return segment.name;
    });
  });
};

module.exports = mySegmentsFetcher;


//////////////////
// WEBPACK FOOTER
// ../~/@splitsoftware/splitio/lib/producer/fetcher/MySegments.js
// module id = 1214
// module chunks = 0